import {
  isPrivateEffice,
  isRootEffice,
  isTextNode,
} from "helpers/efficeHelpers";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectPresenceState } from "slices/efficeCacheSlice";
import { selectSpaceBoxActive } from "slices/spaceMediaSlice";
import { makeSelectNotify } from "slices/sharedSelectors";
import PresentButton from "./PresentButton/PresentButton";
import { goToEffice } from "slices/efficeTreeSlice";
import { PrivateLockBlue } from "graphics/icons/BranchBar/PrivateLock";
import BranchOptions from "graphics/icons/BranchBar/BranchOptions";
import { APP_CODE_BRANCH } from "constants/constants";
import { openInfoPage } from "slices/textSlice";
import AppIcon from "components/Home/ui/AppIcon/AppIcon";

const BranchItem = ({ id, efficeData, isActive, isDarkened, isOpen }) => {
  const selectNotify = useMemo(makeSelectNotify, []);
  const spaceBoxActive = useSelector(selectSpaceBoxActive);
  const notify = useSelector((state) => selectNotify(state, id));
  const peopleInSpace = useSelector((state) => {
    let pState = selectPresenceState(state)[efficeData.permissions_id];
    if (pState && pState[id] && pState[id].length > 0) return pState[id];
    return null;
  });

  const isPrivate = isPrivateEffice(efficeData);
  const isRoot = isRootEffice(efficeData);
  const isText = isTextNode(efficeData);

  return (
    <div
      onClick={() => {
        goToEffice(id);
      }}
      className={`branch-item ${isActive ? "highlighted" : ""} ${
        notify ? "ntfy" : ""
      } ${isDarkened && !spaceBoxActive ? "darkened" : ""} ${
        isRoot ? "root-item" : ""
      }`}
    >
      <span className="branch-icon">
        <AppIcon appId={efficeData.app_id} isOpen={isOpen} />
      </span>
      {isPrivate && !isRoot && <PrivateLockBlue />}
      <span className={`branch-text dotdotdot`}>
        {isText && <span style={{ color: "grey" }}>- Thread - </span>}
        {efficeData.content}
      </span>

      <span className="right-extras">
        {peopleInSpace && (
          <div className="extras-item">
            <PresentButton
              id={id}
              peopleInSpace={peopleInSpace}
              spaceBoxActive={spaceBoxActive}
            />
          </div>
        )}
        <div className="extras-item">
          <button
            className={`more-options ${
              efficeData.app_id === APP_CODE_BRANCH ? "always-shown" : ""
            }`}
            onClick={(e) => {
              goToEffice(id);
              if (efficeData.app_id !== APP_CODE_BRANCH) openInfoPage();
              e.stopPropagation();
            }}
          >
            <div className={`pe-none`}>
              <BranchOptions />
            </div>
          </button>
        </div>
      </span>
    </div>
  );
};

export default BranchItem;
